import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

const SORT_OPTIONS = [
  { label: 'Alphabetically, A-Z', value: 'title-ascending' },
  { label: 'Alphabetically, Z-A', value: 'title-descending' },
  { label: 'Date, old to new', value: 'created-ascending' },
  { label: 'Date, new to old', value: 'created-descending' },
  { label: 'Product count, hight to low', value: 'price-descending' },
  { label: 'Product count, low to high', value: 'price-ascending' },
];

type SortingCollectionType = {
  onChange: (value: string) => void;
  value: string;
};

export default function Sorting({ onChange, value }: SortingCollectionType) {
  return (
    <div className='mt-4 flex flex-col gap-2'>
      <span className='text-sm'>Sorting collections by:</span>
      <Select onValueChange={onChange} value={value}>
        <SelectTrigger>
          <SelectValue placeholder='Alphabetically, A-Z' />
        </SelectTrigger>
        <SelectContent>
          {SORT_OPTIONS.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
